<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/intereses`;
const token = utilsService.getToken();

const interesService = {
  async getInteresOptions() {
    try {
      const response = await axios.get(`${apiUrl}/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener interes options:', error);
      return []; 
    }
  },
};

export default interesService;
</script>
